<template>
	<v-app-bar
		flat
		app
		fixed
		color="#FFFFFF"
		class="z-index-level-2"
		height="64"
	>
		<UserProfileDialog v-model="showProfileDialog" />
		<div class="flex align-center">
			<v-breadcrumbs
				v-if="breadcrumbs"
				:items="breadcrumbs"
				class="custom-styling custom-breadcrumbs"
				:style="customVariable"
			>
				<template v-slot:divider>
					<v-icon>mdi-chevron-right</v-icon>
				</template>
				<template v-slot:item="{ item }">
					<v-breadcrumbs-item
						@click="handleClick(item)"
						:class="item.disabled ? '' : 'cursor-pointer'"
					>
						<v-tooltip bottom v-if="item.tooltipText">
							<template v-slot:activator="{ on, attrs }">
								<span
									v-bind="attrs"
									v-on="on"
									:class="
										breadcrumbs.length > 1 &&
										item.currentPath
											? 'text-mbf-color-2'
											: 'text-mbf-color-4'
									"
									class="
										text-[15px]
										font-bold
										uppercase
										truncate
									"
									:style="{
										maxWidth: `calc((100vw - 400px) / ${
											breadcrumbs.length - 1
										})`,
									}"
								>
									{{ item.text }}
								</span>
							</template>
							<span>
								{{ item.tooltipText }}
							</span>
						</v-tooltip>
						<span
							v-else
							:class="
								breadcrumbs.length > 1 && item.currentPath
									? 'text-mbf-color-2'
									: 'text-mbf-color-4'
							"
							class="text-[15px] font-bold uppercase"
						>
							{{ item.text }}
						</span>
					</v-breadcrumbs-item>
				</template>
			</v-breadcrumbs>
		</div>
		<div
			class="hidden md:flex align-center gap-2 h-full justify-end cursor-pointer"
			style="max-width: 250px"
			@click="showProfileDialog = true"
		>
			<div>
				<v-icon>mdi-account-circle</v-icon>
			</div>
			<div class="grow-0">
				<div class="flex flex-col">
					<span class="font-medium text-xs text-mbf-color-4 truncate"
						>Ông/ Bà
						{{
							currentUserInfo.fullName
								? currentUserInfo.fullName
								: ""
						}}
					</span>
					<span class="font-medium text-xs text-mbf-color-5">
						{{
							currentUserInfo.businessPhones
								? currentUserInfo.businessPhones
								: ""
						}}
					</span>
				</div>
			</div>
		</div>
	</v-app-bar>
</template>

<script>
import userService from "@/services/auth/user.service";
import store from "@/store";
import UserProfileDialog from "@/views/layout/UserProfileDialog.vue";

export default {
	name: "AppBar",
	components: {
		UserProfileDialog,
	},
	props: {},
	data: () => {
		return {
			showProfileDialog: false,
		};
	},
	computed: {
		breadcrumbs() {
			return store.state.breadcrumbs;
		},
		customVariable() {
			return {
				"--mbf-color-4": this.customColors["mbf-color-4"],
			};
		},
	},
	watch: {
		$route: {
			handler(current) {
				if (current) {
					store.commit("SET_BREADCRUMBS", this.getBreadcrumbs());
				}
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		handleClick(item) {
			if (item?.disabled) {
				return;
			}
			this.$router.push({
				path: item?.to,
			});
		},
		async signOut() {
			// Gọi /api/logout (xóa session Redis + token BE), clear storage, về trang login.
			await userService.signOut();
		},
	},
};
</script>

<style scoped lang="scss">
.h-100 {
	height: 100% !important;
}

.w-auto {
	width: auto !important;
}

.custom-styling {
	position: relative;
}

.custom-styling::before {
	content: "";
	position: absolute;
	top: 30%;
	left: 10px; /* Adjust the value to control the length of the border */
	height: 40%;
	width: 3px;
	background-color: var(--mbf-color-4);
}

::v-deep .custom-breadcrumbs .v-breadcrumbs__divider {
	padding: 0 !important;
}
</style>
